import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import styled from "styled-components"


const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  border: none;
  border-bottom: solid 2px ${({ theme }) => theme.primary.light};
  font-size: 16px;
  color: ${({ theme }) => theme.text.primary};
	background: ${({ theme }) => theme.Assist.background};
	outline: none;
	user-select: none;
	caret-color: #ff4081;
  ::placeholder {
    color: ${({ theme }) => theme.faded};
  }
`

const SearchResult = styled.div`
  max-height: 100px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    width: 7.5px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollbar.thumbBackground};
    border-radius: 10px;
  }
`

const Hit = styled.li`
	margin-bottom: 5px;
	height: 15px;
	a {
		display: block;
		color: ${({ theme }) => theme.text.primary};
		span {
			display: inline-block;
			::before{
				vertical-align: middle;
      	content: "💡"
    	}
    }
	}
`

const SearchInputWrapper = styled.div`
	position: relative;
	input {
		&:focus + label {
			display: none;
		}
	}
	label {
		position: absolute;
		top: 12.5px;
		left: 10px;
		color: rgb(110, 110, 110);
		font-size: 15px;
	}
`


const Search = ({ handleHitsCount, isAND }) => {
	const [allPostData, setAllPostData] = useState(null)
	const [searchWord, setSearchWord] = useState("")
	const [result, setResult] = useState([])

	useEffect(() => {
		fetch("/search.json")
			.then(Response => Response.json())
			.then(data => setAllPostData(data))
	}, [])

	useEffect(() => {
		if (searchWord !== "") {
			doSearch()
		}
		else {
			setResult([])
			handleHitsCount(null)
		}
	}, [searchWord, isAND])

	const doSearch = () => {
		const searchResultTmp = allPostData.filter(data => {
			const target = data.title + data.category + data.description + data.html
			var wordList = searchWord.split(/\s+/).filter(v => v)
			var re = new RegExp()
			// AND search
			if (isAND) {
				wordList = wordList.map(word => {
					return "(?=.*" + word + ")"
				})
				re = new RegExp(wordList.join(""), "ig")
			}
			// OR search
			else {
				re = new RegExp(wordList.join("|"), "ig")
			}
			return re.test(target)
		})
		setResult(searchResultTmp)
		handleHitsCount(searchResultTmp.length)
	}

	return (
		<>
			<SearchResult>
				<ul>
					{result.map(a => {
						return (
							<Hit>
								<Link to={a.slug} style={{ display: "block" }}>
									<span>{a.title}</span>
								</Link>
							</Hit>
						)
					})}
				</ul>
			</SearchResult>
			<SearchInputWrapper>
				<SearchInput
					id="search"
					value={searchWord}
					onChange={e => setSearchWord(e.target.value)}
				/>
				<label for="search">
					{searchWord === "" ? <>検索単語を区切って入力</> : null}
				</label>
			</SearchInputWrapper>
		</>
	)
}

export default Search